import CircularRectTextButton from "@/components/CircularButton/styled/CircularRectTextButton";
import { ClassMemberSortByKeys } from "./SetProgressStats/SetProgressStatsTable";
import { StyledTableColumn } from "@/components/styled/table/StyledTable";
import { NoteStudyAnalyticsForUser } from "@knowt/syncing/hooks/study/statsUtils";
import dayjs from "dayjs";
import { spacing } from "@/utils/spacing";
import { iconSizes, strokeWidth } from "@/utils/iconProps";
import { ArrowRightIcon } from "lucide-react";
import { themeColors } from "@/utils/themeColors";

const TestModeColumns = ({
    usersStudyAnalytics,
    onOpenTestPopup,
}: {
    usersStudyAnalytics?: Record<string, NoteStudyAnalyticsForUser> | null;
    onOpenTestPopup: (userId: string | null) => void;
}) => {
    return (
        <>
            <StyledTableColumn title={"Avg Grade"} sortKey={ClassMemberSortByKeys.AVERAGE_GRADE}>
                {(userId: string) => {
                    const percentage = Math.round(usersStudyAnalytics?.[userId]?.averageGrade || 0);
                    return <span>{percentage ? `${percentage}%` : "N/A"}</span>;
                }}
            </StyledTableColumn>
            <StyledTableColumn
                title={"Practice Test"}
                sortKey={ClassMemberSortByKeys.PRACTICE_TEST}
                cellProps={{
                    style: {
                        width: "fit-content",
                    },
                }}>
                {(userId: string) => {
                    const testsTaken = usersStudyAnalytics?.[userId]?.testHistory?.length;

                    return (
                        <CircularRectTextButton
                            disabled={!testsTaken}
                            onClick={() => onOpenTestPopup(userId)}
                            style={{
                                width: "fit-content",
                                padding: `${spacing.XS} ${spacing.MD_S}`,
                                backgroundColor: testsTaken ? themeColors.neutralWhite : themeColors.background,
                                border: testsTaken ? `1px solid ${themeColors.neutral1}` : "none",
                                alignItems: "center",
                                whiteSpace: "nowrap",
                            }}>
                            {!testsTaken ? "Not Started" : `${testsTaken} Test${testsTaken > 1 ? "s" : ""}`}
                            {testsTaken && (
                                <ArrowRightIcon
                                    size={iconSizes.SM}
                                    strokeWidth={strokeWidth.normal}
                                    style={{
                                        marginLeft: spacing.XS,
                                    }}
                                />
                            )}
                        </CircularRectTextButton>
                    );
                }}
            </StyledTableColumn>
            <StyledTableColumn title={"Last Submission"} sortKey={ClassMemberSortByKeys.LAST_SUBMISSION}>
                {(userId: string) => (
                    <span className="secondaryText1">
                        {usersStudyAnalytics?.[userId]?.lastSubmission
                            ? dayjs(usersStudyAnalytics[userId].lastSubmission * 1000).format("MMM DD, YYYY")
                            : "N/A"}
                    </span>
                )}
            </StyledTableColumn>
        </>
    );
};

export default TestModeColumns;
